import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type ImportSettlementRestaurantsResult =
	| { success: true; providers: number; errors: null }
	| { success: false; providers: undefined; errors: MutationHandlerError }

const importSettlementRestaurants = async ({
	settlementId,
}: {
	settlementId: string
}): Promise<ImportSettlementRestaurantsResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation ImportSettlementRestaurants($settlementId: ID!) {
					importSettlementRestaurants(settlementId: $settlementId) {
						success
						error
						providers
					}
				}
			`,
			variables: { settlementId },
			errorPolicy: 'all',
			refetchQueries: ['Settlements'],
		})

		if (errors) return { success: false, providers: undefined, errors }
		const result = data?.importSettlementRestaurants
		if (!result?.success) {
			return {
				success: false,
				providers: undefined,
				errors: result?.error || 'Import fehlgeschlagen',
			}
		}
		return { success: true, providers: result.providers, errors: null }
	} catch (e) {
		if (e && e.networkError)
			return { success: false, providers: undefined, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default importSettlementRestaurants
